<template>
  <v-row justify="center">
    <v-dialog
      overlay-opacity="0.8"
      overlay-color="primary"
      :value="deleteBankDialog"
      persistent
      max-width="800px"
      :content-class="
        deleteBankDialog ? 'elevation-0 d-flex flex-column align-center' : ''
      "
      transition="scroll-y-transition"
    >
      <v-card flat color="transparent" class="d-flex align-center flex-column">
        <div class="text-h3 secondary--text text-center font-weight-bold mb-5">
          Delete Bank Account
        </div>
        <v-card max-width="500px" min-width="400px">
          <v-card-text>
            <v-container>
              <div class="d-flex justify-end mt-n4 mr-n2 mb-4">
                <v-btn icon color="secondary" @click="closeDialog">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
              <v-row>
            
                <v-col cols="12" >
                  <v-text-field
                    :disabled="!sentOTP"
                    v-model="otp"
                    outlined
                    label="Enter OTP*"
                    required
                    type="number"
                    persistent-hint
                    hint="NOTE: You cannot add a previously deleted bank account!"
                  ></v-text-field>
                </v-col>
                
              </v-row>

            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!sentOTP"
              :loading="requestingOTP"
              color="success"
              text
              @click="requestOTP"
              >Request OTP</v-btn
            >
            <v-btn v-else
              :loading="isDeletingBankAccount"
              color="success"
              text
              @click="deleteBankAccount"
              :disabled="!otp"
              >Proceed</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { BankAccountService, UserService } from "@/services/index.js";

export default {
  props: {
    deleteBankDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
    },
  },
  data() {
    return {
      isDeletingBankAccount: false,
      requestingOTP: false,
      sentOTP: false,
      otp: ''
    };
  },
  methods: {
    closeDialog() {
      this.otp = "";
      this.requestingOTP = false;
      this.sentOTP = false;
      this.isDeletingBankAccount = false;
      this.$emit("toggleDialog", false);
    },
    async requestOTP() {
      this.requestingOTP = true;
      this.sentOTP = false;

      try {
        const { message } =  await UserService.requestOTP("deletebank");
        this.$store.commit('openSnackbar', message);

        this.sentOTP = true;
        this.requestingOTP = false;
      } catch (err) {
        this.requestingOTP = false;
      }
    },
    
    async deleteBankAccount() {
      try {
        this.isDeletingBankAccount = true;

       let res = await BankAccountService.delete(this.id, this.otp);

        this.$store.commit("openSnackbar", res.message);

        this.isDeletingBankAccount = false;
        this.closeDialog();
        this.$emit("toggleDialog", false)
      } catch (error) {
        this.isDeletingBankAccount = false;
        // throw error;
      }
    },
   
  },
};
</script>
